// 09-10 (Pau aprobó la maqueta «letrero de sala con resumen»): junto al nombre de cada sala, lo más urgente que le
// toca a Pau en ella con cuántos (la misma insignia que la lista) y cuántos trabajan, en gris. PURO: las cuentas
// salen de resumenCabecera (marco/situacion.ts) con el MISMO contexto que la lista (Santi, las subidas y la hora), así el
// letrero, la carpeta y la cabecera de la lista nunca discrepan. 05-11 (auditoría A): antes no recibía las subidas ni la
// hora, y una subida pendiente no salía ni en la cabecera de su sala ni en su carpeta.
import type { ContratadoDTO } from '../compartido/vocabulario';
import { grupoDelContratado, resumenCabecera, type ContextoEquipo, type Pieza, type SantiPorAgente } from '../marco/situacion';

export interface ResumenLetrero {
  /** Lo más urgente que le toca a Pau en la sala (decidir → no pueden seguir → problema suyo → te han escrito), con su cuenta; null si nada. */
  urgente: Pieza | null;
  /** Trabajando (y llegando), como «N trabajando» de la cabecera. */
  trabajando: Pieza | null;
}

export function resumenLetrero(lista: readonly ContratadoDTO[], santi?: SantiPorAgente, ctx: ContextoEquipo = {}): ResumenLetrero {
  const r = resumenCabecera(lista, santi, ctx);
  // «N trabajando» cuenta lo mismo que la lista: los que trabajan en «En marcha» (el que trabaja con una subida esperando
  // va en «Te toca»; el de un contrato con Santi, en «Con Santi»). Si hay alguno, es la primera pieza de `aparte`.
  const trabajan = lista.some(
    (x) => (x.situacion === 'trabajando' || x.situacion === 'llegando') && grupoDelContratado(x, santi?.get(x.agentId), { subida: ctx.subidas?.get(x.agentId) ?? null, ahora: ctx.ahora }) === 'en_marcha',
  );
  return {
    // La pieza ya lleva su grupo: la pastilla se pinta con su aspecto (Letrero.tsx `aspectoGrupo`), sin buscar a nadie.
    urgente: r.teToca[0] ?? null,
    trabajando: trabajan ? (r.aparte[0] ?? null) : null,
  };
}
